/**
 * Конфиг пошаговой формы заказа (модалка).
 */
export const orderSteps = [
  {
    id: 'size',
    title: 'Размер',
    type: 'tabs' // сами опции берём из store/price
  },
  {
    id: 'orientation',
    title: 'Ориентация',
    type: 'tabs',
    options: [
      { value: 'horizontal', label: 'Горизонтальная' },
      { value: 'vertical', label: 'Вертикальная' }
    ]
  },
  {
    id: 'inscription',
    title: 'Надпись',
    type: 'input',
    placeholder: 'Введите текст надписи (по желанию)',
    name: 'inscription'
  },
  {
    id: 'comment',
    title: 'Ваш комментарий',
    type: 'textarea',
    placeholder: 'Дополнительные пожелания к заказу',
    name: 'comment'
  },
  {
    id: 'contacts',
    title: 'Контактные данные',
    type: 'contacts',
    fields: [
      { id: 'phone', name: 'phone', label: 'Телефон', type: 'tel', placeholder: '+7 (___) ___-__-__', required: false },
      { id: 'email', name: 'email', label: 'Почта', type: 'email', placeholder: 'email@example.com', required: false },
      { id: 'social', name: 'social', label: 'Соц. сети (Telegram, WhatsApp и т.д.)', type: 'text', placeholder: 'По желанию', required: false }
    ]
  },
  {
    id: 'confirm',
    title: 'Подтверждение',
    type: 'preview'
  }
]

export const ORDER_MODAL_SUBMIT_LABEL = 'Оформить заказ'
